import React, {FunctionComponent} from "react";

const Spinner: FunctionComponent = () => {
    return (
        <div className="d-flex justify-content-center mt-3">
            <div className="spinner"></div>
        </div>
    );
};
  
export default Spinner;
  